export enum BookingStatusEnum {
    Default,
    Hold,
    Confirmed,
    Closed,
    HoldCanceled,
    PendingArchive,
    Archived
}

export function getBookingStatusName(status: BookingStatusEnum): string {
    switch (status) {
        case BookingStatusEnum.Hold:
            return "On Hold";
        case BookingStatusEnum.Confirmed:
            return "Confirmed";
        case BookingStatusEnum.Closed:
            return "Closed";
        case BookingStatusEnum.HoldCanceled:
            return "Hold canceled";
        case BookingStatusEnum.PendingArchive:
            return "Pending archive";
        case BookingStatusEnum.Archived:
            return "Archived";
        default:
            return "";

    }
}